import { useState } from "react";

const DEFAULT_FINANCIAL_RUNWAY = [
  "Need income immediately",
  "1-3 months",
  "3-6 months",
  "Secure for 12+ Months (Deep Retraining)",
];

export default function FinancialRunwaySelector({ form, updateField }) {
  const [message, setMessage] = useState("");

  const selected = typeof form.Financial_Runway === "string" ? form.Financial_Runway : "";

  const setMsg = (msg) => {
    setMessage(msg);
    if (msg) setTimeout(() => setMessage(""), 1500);
  };

  const selectRunway = (value) => {
    updateField("Financial_Runway", value); // ✅ store as string
    setMsg("Saved successfully ✅");
  };

  return (
    <div className="rounded-xl border border-pink-400/20 bg-white/5 p-4">
      <div className="flex items-center justify-between gap-3 mb-3">
        <p className="text-pink-300 text-sm font-semibold">
          What is your timeline for getting a new job?
        </p>

        <span className="text-xs text-white/60 whitespace-nowrap">
          {selected ? "1 selected" : "Pick 1"}
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2">
        {DEFAULT_FINANCIAL_RUNWAY.map((option) => (
          <label
            key={option}
            className="min-w-0 flex items-start gap-2 text-[13px] sm:text-sm text-white/85 leading-snug cursor-pointer hover:text-white"
          >
            <input
              type="radio"
              name="financial_runway"
              className="mt-1 accent-pink-500 flex-shrink-0"
              checked={selected === option}
              onChange={() => selectRunway(option)}
            />
            <span className="min-w-0 whitespace-normal break-words">{option}</span>
          </label>
        ))}
      </div>

      {message && (
        <p className={`text-sm mt-2 ${message.includes("Saved") ? "text-green-400" : "text-red-400"}`}>
          {message}
        </p>
      )}
    </div>
  );
}